export default "__VITE_ASSET__DLvKPGFH__"